import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Like ProtectedRoute but requires at least one of the given roles (AspNet role names).
 */
export default function AdminRoute({ component: Component, roles: allowedRoles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const set = new Set((allowedRoles || []).map((r) => (r || '').trim()));
  const userRoles = user?.roles || [];
  const ok = userRoles.some((r) => set.has((r || '').trim()));

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ redirectAfterLogin: location.pathname + location.search }} replace />;
  }

  if (!ok) {
    return <Navigate to="/dashboard" replace />;
  }

  if (Component) return <Component />;
  return children;
}
